import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  AdditionalProduct,
  StoreAdditionalProductPayload,
  UpdateAdditionalProductPayload,
} from '../../models/catalog/additional-product.model';

@Injectable({ providedIn: 'root' })
export class AdditionalProductService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  #items = new BehaviorSubject<AdditionalProduct[]>([]);
  public items$ = this.#items.asObservable();
  public items = toSignal(this.items$, { initialValue: [] });

  getAll() {
    this.#http
      .get<{ data: AdditionalProduct[] }>(
        `${this.#apiUrl}/api/admin/catalog/additional-products`,
      )
      .subscribe({
        next: (response) => this.#items.next(response.data ?? []),
        error: (e) => console.log(e),
      });
  }

  getById(id: number): Observable<{ data: AdditionalProduct }> {
    return this.#http.get<{ data: AdditionalProduct }>(
      `${this.#apiUrl}/api/admin/catalog/additional-products/${id}`,
    );
  }

  create(
    payload: StoreAdditionalProductPayload,
  ): Observable<{ data: AdditionalProduct }> {
    return this.#http.post<{ data: AdditionalProduct }>(
      `${this.#apiUrl}/api/admin/catalog/additional-products`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateAdditionalProductPayload,
  ): Observable<{ data: AdditionalProduct }> {
    return this.#http.patch<{ data: AdditionalProduct }>(
      `${this.#apiUrl}/api/admin/catalog/additional-products/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/additional-products/${id}`,
    );
  }
}
